(() => {
  const libraries = document.querySelectorAll('[data-nabat-family-library]');

  libraries.forEach((library) => {
    const search = library.querySelector('[data-nabat-family-search]');
    const cards = Array.from(library.querySelectorAll('[data-nabat-family-card]'));
    const headings = Array.from(library.querySelectorAll('.nabat-family-letter'));
    const status = library.querySelector('[data-nabat-family-status]');
    const empty = library.querySelector('[data-nabat-family-empty]');
    const isArabic = library.getAttribute('dir') === 'rtl';

    const normalize = (value) => value.toLocaleLowerCase().trim();

    const update = () => {
      const term = normalize(search?.value || '');
      let visible = 0;
      const visibleLetters = new Set();

      cards.forEach((card) => {
        const matchesSearch = !term || normalize(card.dataset.familySearch || '').includes(term);
        const show = matchesSearch;
        card.hidden = !show;
        if (show) {
          visible += 1;
          visibleLetters.add(card.dataset.familyLetter);
        }
      });

      headings.forEach((heading) => {
        heading.hidden = !visibleLetters.has(heading.textContent.trim());
      });

      if (empty) empty.hidden = visible !== 0;
      if (status) {
        status.textContent = isArabic
          ? `${visible} مجموعة نباتية`
          : `${visible} plant ${visible === 1 ? 'family' : 'families'}`;
      }
    };

    search?.addEventListener('input', update);
    update();
  });
})();
